import BaseNodeModel from "../BaseNodeModel";

import * as Papa from "papaparse";

export default class TabNodeModel extends BaseNodeModel {
    /**
     * Tabular router node model
     * @module TabNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Tabular Router";
        this.props.colorClass = "lime";
        this.props.iconClass = "grid";
        this.DEFAULT_COLOR_CLASS = "lime";
        this.applyProps(props);
    }

    setConfig(key, value) {
        if (key === "csvData") {
            // Refresh property panel when reference to CSV data is changed
            document.dispatchEvent(new CustomEvent("ev-property-refresh"));
        }
        super.setConfig(key, value);
        if (key === "matchOrder" || key === "outputTo") {
            const oldInputs = this.getConfig("inputs") ? JSON.parse(JSON.stringify(this.getConfig("inputs"))) : [];
            const oldOutputs = this.getConfig("outputs") ? JSON.parse(JSON.stringify(this.getConfig("outputs"))) : [];
            if (this.getConfig("matchOrder")) {
                const indirectInputs = JSON.parse(JSON.stringify(this.getConfig("matchOrder")));
                var inputs = [];
                for (var i = 0; i < indirectInputs.length; i++) {
                    inputs.push({
                        argumentName: indirectInputs[i].argumentName,
                        id: indirectInputs[i].id,
                        type: indirectInputs[i].type,
                        value: indirectInputs[i].value,
                        varName: indirectInputs[i].varName,
                        senstiveData: indirectInputs[i].senstiveData,
                        ignoreCase: indirectInputs[i].ignoreCase,
                    });
                }
                this.props.config["inputs"] = inputs;
            }
            if (this.getConfig("outputTo")) {
                const indirectOutputs = JSON.parse(JSON.stringify(this.getConfig("outputTo")));
                var outputs = [];
                for (var i = 0; i < indirectOutputs.length; i++) {
                    outputs.push({
                        varName: indirectOutputs[i].varName,
                        scope: indirectOutputs[i].scope,
                        type: indirectOutputs[i].type,
                    });
                }
                this.props.config["outputs"] = outputs;
            }
        }
    }

    getConfigViews() {
        const applicationToolTip = "Parent Tab Node input types/values do not propagate to children.";
        const flowToolTip = "Canvas Tab Node input types/values do not propagate to parent or siblings.";
        const toolTip = this.id === this.props.parentComponentID ? applicationToolTip : flowToolTip;
        // Get the current selection
        const options = window.apm.knowledgeBase.getCSVData();
        const selOptions = [];
        var sel = -1;
        for (var i = 0; i < options.length; i++) {
            selOptions.push({ name: options[i].name, value: options[i].id });
        }
        for (var ds = 0; ds < selOptions.length; ds++) {
            if (selOptions[ds].value === this.getConfig("csvData")) {
                sel = ds;
                break;
            }
        }
        var dropOpts = [];
        if (sel >= 0) {
            const csv = Papa.parse(options[sel].value, {
                header: true,
                preview: 1
            });
            const header = csv.meta.fields;
            for (var i = 0; i < header.length; i++) {
                dropOpts.push({ name: header[i], value: header[i] });
            }
        }
        this.props.configView = [
            { type: "hr" },
            {
                type: "Dropdown",
                key: "csvData",
                label: this.getPropLabel("csv_data"),
                optionName: this.getPropLabel("csv_data_opt"),
                options: selOptions,
                sel: sel,
                readOnly: this.props.isCommonModule
            },
            {
                type: "ItemList",
                label: this.getPropLabel("match_order"),
                key: "matchOrder",
                view: "routerArgument",
                pairKeyView: { colOptions: dropOpts },
                tooltip: toolTip
            },
            {
                type: "ItemList",
                label: this.getPropLabel("output_to"),
                key: "outputTo",
                view: "routerReturn",
                pairKeyView: { colOptions: dropOpts }
            }
        ];
        return [
            ...this.getConfigViewNameField(),
            ...[
                { type: "Textarea", label: this.getPropLabel("description"), key: "description" }
            ],
            ...this.props.configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note" }
            ]
        ];
    }

}